import LegalLayout from './LegalLayout';

export default function PrivacyPage() {
  return (
    <LegalLayout title="Informativa sulla Privacy" lastUpdate="26 Aprile 2026">
      <h2 className="font-outfit text-xl font-bold text-slate-800 mt-0">1. Titolare del trattamento</h2>
      <p className="text-slate-700">
        Il Titolare del trattamento dei dati personali raccolti tramite questa applicazione web (di seguito "Kyloo")
        è Kyloo, contattabile all'indirizzo <strong>kyloo.app@libero.it</strong>.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">2. Tipologie di dati raccolti</h2>
      <p className="text-slate-700">Kyloo raccoglie le seguenti categorie di dati personali:</p>
      <ul className="text-slate-700">
        <li><strong>Dati di registrazione</strong>: email, nome, password (cifrata con bcrypt) o dati forniti tramite Google OAuth (email, nome, foto profilo)</li>
        <li><strong>Dati di utilizzo</strong>: indirizzo IP, log di accesso, prodotti visualizzati, ricerche effettuate</li>
        <li><strong>Dati di geolocalizzazione</strong>: posizione GPS o città inserita manualmente (solo se l'utente lo autorizza)</li>
        <li><strong>Dati negoziante</strong> (per gli utenti professionisti): partita IVA, indirizzo del negozio, email aziendale, orari di apertura, foto e informazioni dei prodotti</li>
        <li><strong>Cookie tecnici e di sessione</strong>: necessari per il funzionamento del servizio (vedi Cookie Policy)</li>
      </ul>

      <h2 className="font-outfit text-xl font-bold text-slate-800">3. Finalità del trattamento</h2>
      <p className="text-slate-700">I dati raccolti vengono utilizzati per:</p>
      <ul className="text-slate-700">
        <li>Erogare il servizio di ricerca e visualizzazione prodotti nei negozi vicini</li>
        <li>Permettere la registrazione e l'autenticazione degli utenti</li>
        <li>Permettere ai negozianti di gestire il proprio catalogo</li>
        <li>Inviare email di verifica account o codici OTP</li>
        <li>Generare statistiche anonime sull'utilizzo del servizio (analytics)</li>
        <li>Migliorare il servizio in base ai feedback ricevuti</li>
        <li>Adempiere a obblighi di legge</li>
      </ul>

      <h2 className="font-outfit text-xl font-bold text-slate-800">4. Base giuridica del trattamento</h2>
      <p className="text-slate-700">
        Il trattamento dei dati avviene sulla base del consenso dell'utente (art. 6, par. 1, lett. a GDPR),
        dell'esecuzione del contratto (art. 6, par. 1, lett. b GDPR) o del legittimo interesse del Titolare
        (art. 6, par. 1, lett. f GDPR).
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">5. Modalità di trattamento e conservazione</h2>
      <p className="text-slate-700">
        I dati sono trattati con strumenti elettronici e protetti con misure di sicurezza adeguate
        (crittografia HTTPS, password con bcrypt, cookie httpOnly + secure, protezione brute-force).
        I dati vengono conservati per il tempo strettamente necessario alle finalità per cui sono raccolti
        e comunque non oltre 24 mesi dall'ultima attività dell'utente, salvo obblighi di legge.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">6. Soggetti terzi</h2>
      <p className="text-slate-700">I dati possono essere comunicati ai seguenti fornitori di servizi:</p>
      <ul className="text-slate-700">
        <li><strong>Google LLC</strong>: per l'autenticazione tramite OAuth (privacy policy su https://policies.google.com/privacy)</li>
        <li><strong>Resend</strong>: per l'invio di email transazionali (privacy policy su https://resend.com/legal/privacy-policy)</li>
        <li><strong>OpenStreetMap</strong>: per il geocoding e la visualizzazione di mappe</li>
        <li><strong>Provider di hosting</strong>: per l'erogazione tecnica del servizio</li>
      </ul>
      <p className="text-slate-700">I dati non vengono ceduti, venduti o diffusi a terzi per finalità commerciali.</p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">7. Diritti dell'interessato</h2>
      <p className="text-slate-700">L'utente può esercitare in qualsiasi momento i diritti previsti dagli artt. 15-22 del GDPR:</p>
      <ul className="text-slate-700">
        <li>Diritto di accesso ai propri dati personali</li>
        <li>Diritto di rettifica</li>
        <li>Diritto alla cancellazione ("diritto all'oblio")</li>
        <li>Diritto di limitazione del trattamento</li>
        <li>Diritto alla portabilità dei dati</li>
        <li>Diritto di opposizione</li>
        <li>Diritto di proporre reclamo al Garante per la Protezione dei Dati Personali</li>
      </ul>
      <p className="text-slate-700">
        Per esercitare questi diritti, scrivi a <strong>kyloo.app@libero.it</strong>.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">8. Minori</h2>
      <p className="text-slate-700">
        Il servizio non è destinato a minori di 16 anni. Non raccogliamo intenzionalmente dati personali di minori.
        Se un genitore/tutore venisse a conoscenza di un trattamento di dati di un minore, può richiederne la
        cancellazione contattando il Titolare.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">9. Modifiche all'informativa</h2>
      <p className="text-slate-700">
        La presente informativa potrà essere aggiornata in qualsiasi momento. Le modifiche saranno pubblicate
        in questa pagina con indicazione della data di ultimo aggiornamento.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">10. Contatti</h2>
      <p className="text-slate-700">
        Per qualsiasi domanda o richiesta relativa al trattamento dei dati personali, scrivi a:
        <br />
        <strong>kyloo.app@libero.it</strong>
      </p>
    </LegalLayout>
  );
}
